module.exports = __webpack_public_path__ + "img/Orbiting-1.b9aeff5f.png";